module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "textcontainer"
  }, [_c('div', [_c('h1', [_vm._v("Paul Gowder: CV")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": _vm.newCVURL,
      "download": "gowdercv.pdf"
    }
  }, [_c('img', {
    staticClass: "cvicon",
    attrs: {
      "src": require("../../assets/icons/file-pdf.svg")
    }
  }), _vm._v(" Download in PDF")])]), _vm._v(" "), _c('h2', [_vm._v("Academic Positions")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h2', [_vm._v("Education")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('publications', {
    attrs: {
      "pubs": _vm.pubs
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Honors, Awards and Grants")]), _vm._v(" "), _c('table', [_c('col', {
    staticStyle: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "80%"
    }
  }), _vm._v(" "), _vm._l((_vm.awards), function(aw) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(aw.year))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(aw.award))])])
  })], 2), _vm._v(" "), _c('h2', [_vm._v("Affiliations")]), _vm._v(" "), _c('table', [_c('col', {
    staticStyle: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "80%"
    }
  }), _vm._v(" "), _vm._l((_vm.affiliations), function(af) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(af.years))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(af.organization))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(af.role))])])
  })], 2), _vm._v(" "), _c('h2', [_vm._v("Presentations (selected)")]), _vm._v(" "), _c('presentations', {
    attrs: {
      "header": "Invited Talks",
      "presentationlist": _vm.pres.invited
    }
  }), _vm._v(" "), _c('presentations', {
    attrs: {
      "header": "Conference Presentations",
      "presentationlist": _vm.pres.conferences
    }
  }), _vm._v(" "), _c('presentations', {
    attrs: {
      "header": "Campus Talks",
      "presentationlist": _vm.pres.campus
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Teaching")]), _vm._v(" "), _c('teaching', {
    attrs: {
      "header": "Lead Instructor",
      "classlist": _vm.courses.lead
    }
  }), _vm._v(" "), _c('p', [_vm._v("Graduate School teaching assistantships ommitted for brevity, but included courses on introductory political philosophy, global justice, the philosophy of race, and corruption.")]), _vm._v(" "), _c('h2', [_vm._v("Legal Practice")]), _vm._v(" "), _c('table', [_c('col', {
    staticStyle: {
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "40%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "40%"
    }
  }), _vm._v(" "), _vm._l((_vm.misc.practice), function(prac) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(prac.years))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(prac.employer))]), _c('td', [_vm._v(_vm._s(prac.role))])])
  })], 2), _vm._v(" "), _c('service', {
    attrs: {
      "servicelist": _vm.svc
    }
  }), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', [_vm._v("Human:")]), _vm._v(" "), _vm._l((_vm.misc.humanlang), function(lang) {
    return _c('p', [_vm._v(" " + _vm._s(lang) + " ")])
  }), _vm._v(" "), _c('p', [_vm._v("Computer:")]), _vm._v(" "), _vm._l((_vm.misc.computerlang), function(lang) {
    return _c('p', [_vm._v(" " + _vm._s(lang) + " ")])
  }), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._l((_vm.misc.bars), function(bar) {
    return _c('p', [_vm._v(" " + _vm._s(bar) + " ")])
  }), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._l((_vm.misc.other), function(o) {
    return _c('p', [_vm._v(" " + _vm._s(o) + " ")])
  }), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._l((_vm.misc.notes), function(n) {
    return _c('p', [_vm._v(" " + _vm._s(n) + " ")])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("2020- "), _c('b', [_vm._v("Frederic P. Vose Professor of Law")]), _vm._v(", Northwestern University Pritzker School of Law\n        "), _c('ul', [_c('li', [_vm._v("Frederic P. Vose Professor of Law from 9/2025-")]), _vm._v(" "), _c('li', [_vm._v("Professor of Law from 2020-8/2025")]), _vm._v(" "), _c('li', [_vm._v("Associate Dean of Research and Intellectual Life 9/2022-8/2024")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("2012-2020 "), _c('b', [_vm._v("Professor of Law and O.K. Patton Fellow in Law")]), _vm._v(", University of Iowa College of Law\n          "), _c('ul', [_c('li', [_vm._v("pre-tenure associate professor 2012-7; tenured and promoted to full 2017; O.K. Patton Fellow in Law 2019-2020\n            ")]), _c('li', [_vm._v("courtesy appointments in political science (2012-20); philosophy (2016-20)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Fall 2019 "), _c('b', [_vm._v("Visiting Professor of Law")]), _vm._v(", Boston University")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("2012 "), _c('b', [_vm._v("Ph.D., Political Science")]), _vm._v(", Stanford University")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("2000 "), _c('b', [_vm._v("J.D.")]), _vm._v(", Harvard Law School")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("1997 "), _c('b', [_vm._v("B.A., Political Science")]), _vm._v(", California State University Los Angeles")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Languages")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Bar Admissions")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Other")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Notes")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e3387400","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cv/cv.vue
// module id = 207
// module chunks = 0